.popper {
  background-color: var(--pri-01);
  background-clip: padding-box;
  border-radius: 4px;
  box-shadow: 1px 1px 8px 1px var(--gray-l);
  z-index: 4;
}